import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import update from 'immutability-helper';

// Mixins / Modules
import isResizable from '../../../mixins/resizable';
import { removeEmptyKeys, deparam } from '../../../../modules/global';
import Window from '../../../../modules/window';

// Related Components
import Agent from './sign_up/agent';
import BookACall from './sign_up/book_a_call';
import ConfirmCall from './sign_up/confirm_call';
import Congratulations from './sign_up/congratulations';
import Consultant from './sign_up/consultant';
import DiscoverySource from './sign_up/discovery_source';
import Industries from './sign_up/industries';
import Pricing from './sign_up/pricing';
import SidebarPitch from './sidebar_pitch';
import Testimonials from './testimonials';
import UserType from './sign_up/user_type';

class SignUp extends React.Component {
  static VIEWS = ['agent', 'consultant', 'book_a_call', 'book_a_call_agent', 'user_type', 'industries', 'discovery_source', 'pricing', 'confirm_call', 'congratulations'];
  static propTypes = {
    forgotPassword: PropTypes.bool,
    activeTab: PropTypes.number,
    consentFormId: PropTypes.number,
    tokenId: PropTypes.string,
    email: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    allowUserType: PropTypes.bool,
    onChangeUserType: PropTypes.func,
    onSignIn: PropTypes.func,
    onSignUp: PropTypes.func,
    setActiveTab: PropTypes.func,
    userType: PropTypes.string,
    domain: PropTypes.string,
  }

  static defaultProps = {
    forgotPassword: false,
    activeTab: 1,
    allowUserType: false,
    onChangeUserType: () => { },
    setActiveTab: () => { },
    domain: '',
  }

  constructor(props) {
    super(props);

    const params = deparam(location.search.slice(1));
    const userType = props.userType ? props.userType : (!!params.ut ? params.ut : '');

    let v;
    if (SignUp.VIEWS.includes(params.v)) {
      v = params.v;
    } else if (['consultant', 'agent'].includes(userType)) {
      v = userType;
    } else {
      v = 'user_type';
    }

    this.state = {
      user: {
        profile_attributes: {
          first_name: props.firstName,
          last_name: props.lastName,
        },
        email: props.email,
        user_type: userType,
        invitation_token: props.tokenId,
        consent_form_id: props.consentFormId,
        allow_marketing: true,
        plan_name: params.plan_name || '',
        plan_duration: params.plan_duration || '',
        plan_message: '',
      },
      v,
    }
  }

  get mainClassName() {
    const { isDesktop } = this.props;
    return classNames('', {
      'width-60pct': isDesktop,
      'width-100pct': !isDesktop,
    });
  }

  get sidebarClassName() {
    const { isDesktop } = this.props;
    return classNames('secondary-background', {
      'fixed right-0 top-0 height-100vh width-40pct': isDesktop,
      'width-100%': !isDesktop,
    });
  }

  get showPitch() {
    const { v } = this.state;
    return ['user_type', 'consultant'].includes(v);
  }

  handleSetView = (v) => {
    this.setState({ v });
  }

  handleUpdateUserType = (userType) => {
    const { user } = this.state;
    const newUser = update(user, { user_type: { $set: userType } });
    this.setState({
      user: newUser
    }, () => {
      if (userType === 'consultant') {
        this.handleSetView('consultant');
      } else if(userType === 'agent') {
        this.handleSetView('agent');
      }
    });
  }

  handleAgentSignUp = (redirectTo, user) => {
    this.setState({
      redirectTo,
      user,
    }, () => {
      this.handleSetView('industries');
    })
  }

  handleConsultantSignUp = (redirectTo, _user) => {
    Window.redirect(redirectTo);
  }

  handleSubscribe = (user, v) => {
    this.setState({
      v,
      user,
    });
  }

  render() {
    const { onSignIn } = this.props;
    const { v, user, redirectTo  } = this.state;

    if (v === 'pricing') {
      return <Pricing {...{
        user,
        onSetView: this.handleSetView,
        onSubscribe: this.handleSubscribe,
      }} />
    } else if (v === 'confirm_call') {
      return <ConfirmCall />
    } else if (v === 'congratulations') {
      return <Congratulations />
    }

    return (
      <React.Fragment>
        <div className={this.mainClassName}>
          {
            v === 'user_type' &&
            <UserType {...{
              onUpdate: this.handleUpdateUserType,
              onSetView: this.handleSetView,
              onSignIn,
            }} />
          }
          {
            v === 'agent' &&
            <Agent {...{
              user,
              onSetView: this.handleSetView,
              onSignUp: this.handleAgentSignUp,
              onSignIn,
            }} />
          }
          {
            v === 'consultant' &&
            <Consultant {...{
              user,
              onSetView: this.handleSetView,
              onSignUp: this.handleConsultantSignUp,
              onSignIn,
            }} />
          }
          {
            v === 'industries' &&
            <Industries {...{
              user,
              onSetView: this.handleSetView,
            }} />
          }
          {
            v === 'book_a_call' &&
            <BookACall {...{
              redirectTo,
              onSetView: this.handleSetView,
            }} />
          }
          {
            v === 'discovery_source' &&
            <DiscoverySource {...{
              user,
              onSetView: this.handleSetView,
            }} />
          }
          {
            v === 'book_a_call_agent' &&
            <BookACall {...{
              redirectTo,
              onSetView: this.handleSetView,
              showProgress: true,
            }} />
          }
        </div>
        <div className={this.sidebarClassName}>
          <div className='margin-center'>
            {
              this.showPitch &&
              <SidebarPitch />
            }
            {
              !this.showPitch &&
              <Testimonials />
            }
          </div>
        </div>
      </React.Fragment>
    )
  }
}
export default isResizable(SignUp);